import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import DepositEntryPoints from '#app/entrypoints/deposit';
import { Option } from '#app/typings/utils';

type HookReturn = {
  deposits: Option[];
};

const useDeposits = (limited: boolean = false): HookReturn => {
  const { data: deposits } = useSWR<Option[]>(
    generateApiPath(DepositEntryPoints.getSelect, {}, { limited }),
    getCollection,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    deposits: deposits ?? [],
  };
};

export default useDeposits;
